import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

/**
 * @param {HTMLElement} root
 */
function destroyCareersLifeSplides(root) {
  if (!root || !root.querySelectorAll) {
    return;
  }
  root.querySelectorAll('[data-careers-life-splide]').forEach((el) => {
    if (!(el instanceof HTMLElement)) {
      return;
    }
    const inst = el._careersLifeSplide;
    if (inst && typeof inst.destroy === 'function') {
      inst.destroy(true);
    }
    delete el._careersLifeSplide;
    delete el.dataset.careersLifeSplideInit;
  });
}

/**
 * @param {HTMLElement} el
 */
function mountCareersLifeSplide(el) {
  if (!(el instanceof HTMLElement)) {
    return;
  }

  const slides = el.querySelectorAll('.splide__slide');
  if (slides.length < 1) {
    return;
  }

  const existing = el._careersLifeSplide;
  if (existing && typeof existing.destroy === 'function') {
    existing.destroy(true);
  }
  delete el._careersLifeSplide;

  const baseSpeed = parseFloat(el.dataset.scrollSpeed || '0.20') || 0.20;
  const autoScrollSpeed = Math.min(0.5, Math.max(0.03, baseSpeed * 0.25));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loopType = slides.length > 1 ? 'loop' : 'slide';

  const splide = new Splide(el, {
    type: loopType,
    drag: 'free',
    snap: true,
    arrows: false,
    pagination: false,
    gap: '16px',
    autoWidth: true,
    /* Symmetric insets on the track (not the section) so slides are not clipped by outer padding */
    padding: {
      left: '40px',
      right: '40px',
    },
    focus: slides.length > 1 ? 'center' : 0,
    breakpoints: {
      767: {
        gap: '10px',
        padding: {
          left: '24px',
          right: '24px',
        },
      },
    },
    ...(reduced
      ? {}
      : {
          autoScroll: {
            speed: autoScrollSpeed,
            pauseOnHover: true,
            pauseOnFocus: true,
            rewind: false,
          },
        }),
  });

  splide.mount(reduced ? {} : { AutoScroll });

  splide.on('mounted', () => {
    window.requestAnimationFrame(() => {
      splide.refresh();
    });
  });

  el._careersLifeSplide = splide;
  el.dataset.careersLifeSplideInit = '1';
}

/**
 * @param {ParentNode} root
 */
function initCareersLifeSplides(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('[data-careers-life-splide]').forEach((el) => {
    if (!(el instanceof HTMLElement)) {
      return;
    }
    mountCareersLifeSplide(el);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCareersLifeSplides(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initCareersLifeSplides(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyCareersLifeSplides(event.target);
});
